import React from "react";
import queryString from "query-string";
import "./App.css";
import Nocode from "./Nocode";
import Iframe from "./Iframe";

const parsed = queryString.parse(window.location.search);

function getParsedButton() {
  if (parsed.buttonid) {
    return <Nocode parsed={parsed} />;
  } else if (parsed.ibuttonid) {
    return <Iframe parsed={parsed} />;
  }
}

const App = () => {
  return getParsedButton();
};

export default App;
